module.exports = __webpack_public_path__ + "img/ios_qr_code.22c7ce17.png";